import * as yup from 'yup'
import { HOST_REGEX, NUMBER_REGEX } from 'utils/constants'
import {
  chainFormFields as CFF,
  chainParentFields,
  FileSourceType,
} from 'components/chainManagement/utils'

const stringSchema = yup.string().trim()

const internalFtpSchema = yup.object().shape({
  [CFF.FTP_BASE_DIRECTORY.key]: stringSchema.required(
    'FTP Base Directory is a required field',
  ),
})

const chainFtpSchema = yup.object().shape({
  [CFF.FTP_PROTOCOL.key]: stringSchema.required(
    'FTP Protocol is required field',
  ),

  [CFF.FTP_HOST.key]: stringSchema
    .required('FTP Host is required field')
    .matches(HOST_REGEX, {
      message: 'Please provide a valid host',
      excludeEmptyString: true,
    }),

  [CFF.FTP_PORT.key]: stringSchema
    .ensure()
    .required('FTP Port is required field')
    .matches(NUMBER_REGEX, {
      message: 'FTP Port must be a positive numerical value',
      excludeEmptyString: true,
    }),

  [CFF.FTP_USERNAME.key]: stringSchema.required(
    'FTP Username is a required field',
  ),

  [CFF.FTP_PASSWORD.key]: stringSchema.required(
    'FTP Password is a required field',
  ),

  [CFF.FTP_BASE_DIRECTORY.key]: stringSchema.required(
    'FTP Base Directory is a required field',
  ),
})

export const createChainSchema = yup.object().shape({
  [CFF.CHAIN_ID.key]: stringSchema.required(
    `${CFF.CHAIN_ID.label} is required field`,
  ),
  [CFF.CHAIN_NAME.key]: stringSchema.required(
    `${CFF.CHAIN_NAME.label} is required field`,
  ),
  [CFF.CHAIN_IS_ACTIVE.key]: yup.boolean(),
  [CFF.FILE_SOURCE_TYPE.key]: stringSchema.required(
    `${CFF.FILE_SOURCE_TYPE.label} is required field`,
  ),
  [chainParentFields.FTP]: yup.object().when(CFF.FILE_SOURCE_TYPE.key, {
    is: (val: string) => val === FileSourceType.CHAIN_FTP,
    then: () => chainFtpSchema,
    otherwise: () =>
      yup.object().when(CFF.FILE_SOURCE_TYPE.key, {
        is: (val: string) => val === FileSourceType.INTERNAL_FTP,
        then: () => internalFtpSchema,
        otherwise: () => yup.object().optional().nullable().strip(),
      }),
  }),
})

export const updateChainSchema = createChainSchema.shape({
  [CFF.CHAIN_ID.key]: stringSchema.optional(),
})
